import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Globals } from '../objects/Globals';
import { EnvService } from '../env.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../objects/Globals";
import * as i3 from "../env.service";
var InputComboService = /** @class */ (function () {
    function InputComboService(http, globals, env) {
        this.http = http;
        this.globals = globals;
        this.env = env;
        this.serviceUrl = this.env.servicePath;
    }
    InputComboService.prototype.createInputComboCard = function (type) {
        var path = this.serviceUrl + "CreateInputComboCard/" + type;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.post("" + path, "", httpOptions);
    };
    InputComboService.prototype.getInputComboList = function (id, inputFilter) {
        if (inputFilter === void 0) { inputFilter = ""; }
        var path = this.serviceUrl + "GetInputComboList/" + id + "?inputFilter=" + inputFilter;
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
        };
        return this.http.get("" + path, httpOptions);
    };
    InputComboService.ngInjectableDef = i0.defineInjectable({ factory: function InputComboService_Factory() { return new InputComboService(i0.inject(i1.HttpClient), i0.inject(i2.Globals), i0.inject(i3.EnvService)); }, token: InputComboService, providedIn: "root" });
    return InputComboService;
}());
export { InputComboService };
